import React from 'react';
import FundOption from '../component/fundOption'
import { formatDate } from '../common/helper'
import HistoricalUnitPricesTable from '../component/historicalTable'
import { historicalDownloadHandler } from '../common/helper'
import DatetimePick from '../component/datePicker'
import Footer from "../component/footer";
import moment from "moment";

class ANZHistoricalUnitPrices extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            FindByReportTypeData: [],
            fundOptionJson: [],
            FirstTableHeader: "",
            startlocalDate: formatDate(this.props, new Date().toDateString(), 3),
            endlocalDate: formatDate(this.props, new Date().toDateString(), 3),
            selectedFundOption: "",
            tableSHow: false,
            errorMessageShow: false,
            tableErrorMsgShow: false,
            refreshPagination:false
        }
    }

    componentDidMount() {
        document.title = 'ANZ Historical Unit Prices';
        fetch('/api/historical-unit-prices/funds?reportName=ANZUnitprices',{
        method:'GET',
            headers:{
              'Content-Type':'application/json;charset=UTF-8',
            },
          mode:'same-origin',
            cache:'default'
          })
           .then(res =>res.json())
           .then((data) => {
                this.setState({
                     fundOptionJson:data.data,
                })
            })
    }

    shouldComponentUpdate(nextState){
        return (nextState.selectedFundOption !== this.state.selectedFundOption) ||
                (nextState.startlocalDate !== this.state.startlocalDate) ||
                (nextState.endlocalDate !== this.state.endlocalDate)  ||
                (nextState.tableSHow !== this.state.tableSHow)
    }


    handleSubmit = (e) => {
        e.preventDefault();
         if (this.state.selectedFundOption === '') {
            this.setState({
                errorMessageShow: true
            })
        } else {
            if(this.state.errorMessageShow){
                this.setState({
                    errorMessageShow: false
                })
            }else{
                console.log("errorMessageShow: false")
            }

             let fromParameter = moment(this.state.startlocalDate,"DD/MM/YYYY");
             let toParameter = moment(this.state.endlocalDate,"DD/MM/YYYY");


            const baseUrl= '/api/historical-unit-prices/'
            const fullUrl = baseUrl +'?fromDate=' + fromParameter.format("DD/MM/YYYY") + '&fund=' + this.state.selectedFundOption + '&reportName=ANZUnitprices&toDate=' + toParameter.format("DD/MM/YYYY");
            fetch(fullUrl,{
                method:'GET',
                headers:{
                  'Content-Type':'application/json;charset=UTF-8',
                },
              mode:'same-origin',
                cache:'default'
              })
               .then(res =>res.json())
               .then((data) => {
                    if(data.status === "FAILURE"){
                        this.setState({
                            tableSHow: true,
                            FindByReportTypeData: [],
                            FirstTableHeader: "",
                            tableErrorMsgShow: true,
                            })
                    }else{
                        this.setState({
                            tableSHow: true,
                            FindByReportTypeData: data.data,
                            FirstTableHeader: data.data[0].columnHeading,
                            tableErrorMsgShow: false,
                            refreshPagination : true
                            })
                    }
                })
        }
    }

    cancelButton = () => {
        window.location.reload()
    }

    setSelectedFundOption = (item) => {
        this.setState({
            selectedFundOption: item
        })
    }

    setStartDate = (item) => {
        this.setState({
            startlocalDate: item
        })
    }

    setEndDate = (item) => {
        this.setState({
            endlocalDate: item
        })
    };

    setRefreshPagination = (boolean) => {
        this.setState({
            refreshPagination: boolean
        })
    };

    render() {
        const { FindByReportTypeData } = this.state;
        let fundOption =[];

        this.state.fundOptionJson.map((item) =>{
            const option = item.fundOptionsList.map((list) => {
                return {
                    label: list.fundName,
                    value: list.fundCode
                }
            })
            fundOption.push({
                label:item.heading,
                options: option,
            })
        })

        return (
        <div style={{ width: "100%" }} >
            <div style={{ marginBottom: "30px" }} >
                <div class="container" style={{paddingLeft:"0px"}}>
                    <form onSubmit={this.handleSubmit} >
                        <div className="form-row">
                            <div class="form-group" >
                                <div class="col-md-12 formItemStyle" >
                                    <h1 className="header1"> Historical Unit Prices </h1 >
                                </div>
                                <div className="col-md-6 col-sm-12 formItemStyle">
                                    <label className="formItemStyle" id="aria-label" htmlFor="aria-fund-input"> Fund </label>
                                    <FundOption selectedFundValue={this.state.selectedValue}  itemOption={fundOption}
                                                selectedFundOption={this.setSelectedFundOption} />
                                    <div className="formItemStyle"
                                         style={this.state.errorMessageShow ? {display: "block"} : {display: "none"}}>
                                        <div className="alert alert-danger" role="alert" style={{marginBottom: "0px"}}>
                                            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"
                                                  style={{marginRight: "8px"}}></span>
                                            <span className="sr-only">Error: </span>
                                            Please select one of the Funds
                                        </div>
                                    </div>
                                </div>
                                <DatetimePick startDate = {this.setStartDate} endDate =  {this.setEndDate} />
                            </div>

                                <div class="form-group">
                                    <div className="col-md-12 col-sm-12 formItemStyle"  style={{ marginBottom: "30px", marginTop:"10PX" }}>
                                    <button type="submit" id='submit'class="submit-button" style={{ marginRight: "20px", width: "135px" }} > Show prices </button>
                                    <button type="button"class="download-button" style={{ width: "135px" }}  onClick = {this.cancelButton}> Reset </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <hr className="section-divider"/>
            </div>

            <div class="container" style={this.state.tableSHow?{display:"block"}:{display:"none"}}>
                { /* Error Message */}
                <div style={this.state.tableErrorMsgShow?{display:"block"}:{display:"none"}}>
                    <div class="alert alert-danger" role="alert" style={{marginBottom: "0px"}}>
                        <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" style={{marginRight:"8px"}}></span>
                        <span class="sr-only">Error: </span>
                        There is no data matching based on input. Please check your input and try it again.
                    </div>
                    <br></br>
                </div>
                <form  >
                    { /* Download */}
                    <div className="dropdown downloadIcon historical-button-download">
                        <button className="download-button" type="button" id="dropdownMenu1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style={{ width: "135px" }}>
                            Download
                            <span className="download-icon"></span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenu1">
                            <li><a onKeyDown={e=> e.key === 'Enter' && historicalDownloadHandler('pdf', 'anzunitprices', this.state.selectedFundOption, this.state.startlocalDate, this.state.endlocalDate )}
                                   onClick={()=>historicalDownloadHandler('pdf', 'anzunitprices', this.state.selectedFundOption, this.state.startlocalDate, this.state.endlocalDate )}
                                   className="dropdown-item" tabIndex='0'>Acrobat (PDF) file</a></li>
                            <li><a onKeyDown={e=> e.key === 'Enter' && historicalDownloadHandler('csv', 'anzunitprices', this.state.selectedFundOption, this.state.startlocalDate, this.state.endlocalDate )}
                                   onClick={()=>historicalDownloadHandler('csv', 'anzunitprices', this.state.selectedFundOption, this.state.startlocalDate, this.state.endlocalDate )}
                                   className="dropdown-item" tabIndex='0'>CSV (comma delimited)</a></li>
                            <li><a onKeyDown={e=> e.key === 'Enter' && historicalDownloadHandler('excel', 'anzunitprices', this.state.selectedFundOption, this.state.startlocalDate, this.state.endlocalDate )}
                                   onClick={()=>historicalDownloadHandler('excel', 'anzunitprices', this.state.selectedFundOption, this.state.startlocalDate, this.state.endlocalDate )}
                                   className="dropdown-item" tabIndex='0'>Excel</a></li>
                            <li><a onKeyDown={e=> e.key === 'Enter' && historicalDownloadHandler('xml', 'anzunitprices', this.state.selectedFundOption, this.state.startlocalDate, this.state.endlocalDate )}
                                   onClick={()=>historicalDownloadHandler('xml', 'anzunitprices', this.state.selectedFundOption, this.state.startlocalDate, this.state.endlocalDate )}
                                   className="dropdown-item" tabIndex='0'> XML file with report data</a></li>
                        </ul>
                    </div>
                    { /* BootstrapTable */}
                    <HistoricalUnitPricesTable FirstTableHeader={this.state.FirstTableHeader} FindByReportTypeData={FindByReportTypeData} refreshPagination={this.state.refreshPagination} setRefreshPagination={this.setRefreshPagination}/>
                </form>
            </div>
        </div>


        )
    }
}

export default ANZHistoricalUnitPrices;
